import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ModelService } from 'src/app/services/model.service';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/app.config';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';

@Injectable({
	providedIn: 'root'
})

export class LoginService {

	public loginError: boolean = false;
	public emailExists: boolean = false;
	public notActiveError: boolean = false;
	public connectivityError: boolean = true;
	public accountCreated: boolean = false;
	public passwordRecover: boolean = false;

	//public conectivityError = false;

	constructor(
		private http: HttpClient,
		private modelService: ModelService,
		private router: Router
	) { }

	public login(username: string, password: string): Observable<any> {

		this.accountCreated = false;
		this.passwordRecover = false;
		this.loginError = false;


		return this.http.post(ConfigService.REST_SERVER + '/api/login', { email: username, password: password })
			.pipe(
				//map((response: Response) => {
				map(res => {
					if (res && res["token"]) {
						this.loginError = false;
						this.notActiveError = false;
						this.connectivityError = false;
						this.accountCreated = false;
						this.passwordRecover = false;
						this.modelService.getUser().setAuthToken(res["token"]);
						this.modelService.getLanguage().setLanguage(res["idioma"]);
						location.reload();
						return { ok: true, id: res["id"], rol: res["rol"] };

					} else {
						this.loginError = true;
						return false;
					}
					
				}),
				catchError((res, caught): Observable<any> => {
					//console.log('### Fallo en login: url=' + ConfigService.REST_SERVER);
					if (res.status === 401) this.loginError = true;
					if (res.status === 403) this.notActiveError = true;
					//JGG: Esta es la version antigua de devolver el Observable en las versiones < 6 de rxjs
					//return Observable.throw(res.json());
					return throwError(res);
				})
			);
	}

	public register(registerData: Object): Observable<any> {
		return this.http.post(ConfigService.REST_SERVER + '/api/register', registerData)
			.pipe(
				map((response: Response) => {
					if (response && response.ok === false) {
						this.emailExists = true;
						return response;
					}
					else {
						this.accountCreated = true;
						this.loginError = false;
						this.notActiveError = false;
						this.connectivityError = false;
						this.passwordRecover = false;
					}
				}),
				catchError((res, caught): Observable<any> => {
					//console.log('### Fallo en registro de usuario: url=' + ConfigService.REST_SERVER);
					//console.log(res);
					if (res.status === 401) this.loginError = true;
					if (res.status === 403) this.notActiveError = true;

					//JGG: Esta es la version antigua de devolver el Observable en las versiones < 6 de rxjs
					//return Observable.throw(res.json());
					return throwError(res);
				})
			);
	}

	public recover(email: string): Observable<any> {
		return this.http.get(ConfigService.REST_SERVER + '/api/newPwd/user/' + email)
			.pipe(map((response: Response) => {
				this.passwordRecover = true;
				this.loginError = false;
				this.notActiveError = false;
				this.connectivityError = false;
				this.accountCreated = false;
			}));
	}

	public logout(): void {
		// remove user from local storage to log user out
		this.modelService.getUser().logout();
		this.modelService.logoutSignal.emit(true);
	}

	public isLoggedIn() {
		var jwtDecode = require('jwt-decode');

		if (localStorage.getItem('authToken')) {
			var decoded = jwtDecode(localStorage.getItem('authToken'));
			if (Date.now() <= decoded.exp * 1000) {
				return true;
			}
		}
		this.logout();
		this.router.navigate(['/login']);
		return false;
	}
}
